<h3>Update User</h3>
ID: {{user?.id}}<br />
Name: {{user?.name}}<br />
Email: {{user?.email}}<br />
Active: {{user?.active ? 'yes' : 'no'}}<br />

<h5 class="mt-3">Configuration</h5>

<div *ngIf="user?.client?.name">
  <config-field [inputValue]="logoSignal" title="Logo" name="logoRadio" />
  <config-field [inputValue]="emailSignal" title="Email" name="emailRadio" />
  <config-field [inputValue]="websiteSignal" title="Website" name="websiteRadio" />

  <div class="mb-3">
    <!-- Label -->
    <label class="form-label">Excel</label>
    <div class="row gx-3 align-items-baseline">

      <!-- Excel checkbox -->
      <div class="col">
        <input type="checkbox" class="form-check-input me-2" id="test" [checked]="excelSingleSpreadsheet()" (change)="excelSingleSpreadsheetCheckedChanged($event)" />
        <label for="test" class="form-label">Single Excel</label>
      </div>
    </div>
  </div>

  <!-- Submit Button -->
  <button type="button" class="btn btn-primary position-absolute" title="Save Configuration" (click)="onSave()">Save</button>
</div>

<div *ngIf="user && !user?.client?.name">
  Not supported
</div>